import React from 'react';

import { Button } from 'shared/components';
import Icon from 'components/Icon';

import { useIntl } from 'react-intl';
import {
  useStationsOperations,
  useShowVisibleStations
} from 'entities/stations';
import { useStyles } from './styles';
import { useMediaQuery } from 'common/hooks';

import { STATIONS_DISPLAY_BUTTON_ID } from './constants';

export const StationsDisplayButton = () => {
  const { formatMessage } = useIntl();
  const { isMobile } = useMediaQuery();
  const { updateVisibleStationsDisplay } = useStationsOperations();
  const showVisibleStations = useShowVisibleStations();
  const classes = useStyles({ showStations: showVisibleStations });

  return (
    <Button
      onClick={() => {
        updateVisibleStationsDisplay(!showVisibleStations);
      }}
      disableElevation={false}
      id={STATIONS_DISPLAY_BUTTON_ID}
      variant="contained"
      classes={{ root: classes.button }}
      mobileButton={isMobile}
    >
      <Icon
        kind="pointDisable"
        classes={{
          root: classes.icon
        }}
      />
      {
        !isMobile && (
          formatMessage({ id: showVisibleStations ? 'hideStations' : 'showStations' })
        )
      }
    </Button>
  );
};
